(function () {
  if (window.__kkInit) return;
  window.__kkInit = true;

  function initSlider(root) {
    var slides = [].slice.call(root.querySelectorAll('.kslide'));
    if (slides.length < 2) return;
    var section = root.closest('.khero');
    var dots = section ? [].slice.call(section.querySelectorAll('[data-kk-dots] button')) : [];
    var cur = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(n) {
      cur = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === cur); });
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === cur ? 'true' : 'false'); });
    }
    function auto() { clearInterval(timer); if (!reduce) timer = setInterval(function () { go(cur + 1); }, 5000); }
    var prev = section && section.querySelector('[data-kk-prev]');
    var next = section && section.querySelector('[data-kk-next]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); auto(); });
    if (next) next.addEventListener('click', function () { go(cur + 1); auto(); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); auto(); }); });
    var sx = null;
    root.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(cur + (dx < 0 ? 1 : -1)); auto(); }
      sx = null;
    });
    auto();
  }

  function init() {
    document.querySelectorAll('[data-kk-slider]').forEach(initSlider);

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-kk-rail]');
      if (b) {
        var r = document.getElementById(b.getAttribute('data-kk-rail'));
        if (r) r.scrollBy({ left: Number(b.getAttribute('data-dir')) * r.clientWidth * 0.8, behavior: 'smooth' });
      }
      var t = e.target.closest('[data-kk-age]');
      if (t) {
        var wrap = t.closest('.kk');
        var age = t.getAttribute('data-kk-age');
        wrap.querySelectorAll('[data-kk-age]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        wrap.querySelectorAll('[data-ages]').forEach(function (c) {
          c.hidden = !(age === 'all' || (' ' + c.getAttribute('data-ages') + ' ').indexOf(' ' + age + ' ') > -1);
        });
      }
    });

    var bar = document.querySelector('.kcodbar');
    if (bar) {
      var onScroll = function () { bar.classList.toggle('is-show', window.scrollY > 560); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    // Reel videos: play only while on screen to save data on 4G phones.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
        });
      }, { threshold: 0.4 });
      document.querySelectorAll('video[data-kk-autoplay]').forEach(function (v) { io.observe(v); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
